/* src/app/modules/expense-reports/components/reports-review/reports-review.component.scss */
@media (max-width: 575.98px) {
  .table-container {
    padding: 0.5rem !important;
  }
  .table-responsive {
    overflow-x: auto;
  }
  .table {
    font-size: 0.85rem;
    min-width: 700px;
  }
  .row,
  .col-md-1,
  .col-md-2 {
    margin: 0 !important;
    padding: 0 !important;
  }
}
/*# sourceMappingURL=reports-review.component.css.map */
